import * as React from 'react';
import { CustomerNotification as InlineNotification, CustomerNotificationLocation as InlineNotificationLocation } from '@shared-ui/customer-notifications';
import { usePlatformContext } from '@bernie/platform-context';
import { inject } from 'mobx-react';
import { useLocation } from 'react-router-dom';
var CustomerNotificationsComponent = function (_a) {
    var _b, _c;
    var page = _a.page, location = _a.location, journeyCriterias = _a.journeyCriterias;
    // Since this component expects its own `location` prop, using `withRouter` HOC causes prop collision
    var routeLocation = useLocation();
    var context = usePlatformContext().context;
    if (!page || !page.pageId) {
        return null;
    }
    var referer = null;
    if (((_b = context === null || context === void 0 ? void 0 : context.site) === null || _b === void 0 ? void 0 : _b.domain)
        && routeLocation && routeLocation.pathname) {
        var domain = context.site.domain;
        var search = routeLocation.search, path = routeLocation.pathname;
        referer = new URL("https://".concat(domain).concat(path).concat(search));
    }
    var optionalContext;
    if (journeyCriterias) {
        optionalContext = {
            referer: referer,
            journeyCriterias: journeyCriterias
        };
    }
    else {
        optionalContext = {
            referer: referer
        };
    }
    var skipSsr = false;
    if (routeLocation && routeLocation.search) {
        var queryParams = new URLSearchParams(routeLocation.search);
        skipSsr = (_c = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('mdpcid')) === null || _c === void 0 ? void 0 : _c.includes('hotelscombined');
    }
    return (React.createElement("div", { className: "customer-notification-container" },
        React.createElement(InlineNotification, { inputs: {
                xPageId: page.pageId,
                notificationLocation: InlineNotificationLocation[location],
                optionalContext: optionalContext
            }, skipSsr: skipSsr })));
};
export var CustomerNotifications = React.memo(inject('page')(CustomerNotificationsComponent));
//# sourceMappingURL=customer-notifications.js.map